<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/user']"><img src="assets/images/admin/backarrow.png" /> Back to User Management</a>
    <!-- <div class="logout">
        <b>Pratibha Sharma</b>
        <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <!-- <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userDetail">
                    <h2>Rajeev Srivastava<small>Created on 3 Feb, 2021</small></h2>
                    <h3>Central Railway Zone</h3>
                    <div class="userDetailSocial">
                        <a href="mailto:rajeevsrivastava@gmail.com"><b><img src="assets/images/admin/mail.png" /></b>rajeevsrivastava@gmail.com</a>
                        <a href="tel:+9197465 73721"><b><img src="assets/images/admin/phone.svg" /></b>+91 97465 73721</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/view_courses']">VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']">ASSIGN COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']">EDIT</a> </li>
                    <li class="deactiveTab"><a href="javascript:void(0);"  class="active" [routerLink]="['/user_deactive']">DEACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div> -->
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12 col-md-6" *ngIf="userDetail">
                    <div class="userDetail">
                        <h2>{{userDetail.first_name}} {{userDetail.last_name}}<small>Created on
                                {{userDetail.created_dttm | date:'d MMM, y'}}</small></h2>

                        <h3>{{userDetail.organisation_name}}</h3> 
                         <!-- organization name visibale Milan -->
                        <!-- <h3>{{organisation_name}}</h3> -->
                        <div class="userDetailSocial">
                        
                            <a href="mailto:userDetail.email"><b><img src="assets/images/admin/mail.png" /></b>{{userDetail.email}}</a>
                            <a href="tel:+userDetail.phone"><b><img src="assets/images/admin/phone.svg" /></b>{{userDetail.phone}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/view_courses']" [queryParams]="{user_id:userID}"
                            >VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']"
                            [queryParams]="{user_id:userID}">ASSIGN COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']"
                            [queryParams]="{id:userID,type:'edit'}">EDIT</a> </li>
                    <li *ngIf="userDetail?.is_active==1" class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']"
                            [queryParams]="{user_id:userID}"  class="active">DEACTIVATE</a> </li>
                    <li *ngIf="userDetail?.is_active==0" class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']"
                                [queryParams]="{user_id:userID}"  class="active">ACTIVATE</a> </li>
                   
                </ul>
            </div>
        </div>
    </div>
    <div class="deactiveWrap">
        <p *ngIf="userDetail?.is_active==1">Are you sure you want to Deactivate this user?</p>
        <p *ngIf="userDetail?.is_active==0">Are you sure you want to Activate this user?</p>
        <div class="d-flex w-100 align-items-center justify-content-center">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" [routerLink]="['/user']">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(userDetail?.user_id,0)" *ngIf="userDetail?.is_active==1">Yes, DeActivate</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(userDetail?.user_id,1)" *ngIf="userDetail?.is_active==0">Yes, Activate</a>
        </div>
    </div>
</div>
